import React, { useState, useEffect } from "react";
import "../../styles/serviceCallStyles/ServiceConfirmation.css";

import Steps from "../Steps";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";

const ServiceConfirmation = ({ onGoToServiceDetails }) => {
  const [currentStep, setCurrentStep] = useState("Summary");

  const serviceDescription = JSON.parse(localStorage.getItem("serviceData"));
  const sd = JSON.parse(localStorage.getItem("serviceId"));
  const steps = [
    "Service Call Description",
    "Tasks and Team",
    "Service Call Dates",
    "Additional Details",
    "Summary",
  ];

  // Load project address from local storage
  useEffect(() => {
    localStorage.removeItem("serviceData");
    // Clear relevant local storage items after loading data
    // localStorage.removeItem("serviceData");
    localStorage.removeItem("selectedTasks");
    localStorage.removeItem("dateRanges");
    localStorage.removeItem("uploadedFiles");
  }, []);

  return (
    <div className="service-confirmation-container">
      <div className="service-confirmationScreen">
        <Steps
          currentStep={currentStep}
          setCurrentStep={setCurrentStep}
          steps={steps}
        />
        <div className="serviceconfirmation-header-container">
          <h3 className="confirm">Project {sd ? "Updated" : "Created"}</h3>

          <div className="service-confirmation-message">
            <img
              src="/images/confirm.svg"
              alt="Confirmation Icon"
              className="confirmation-icon"
            />
            <span>
              Awesome! Service Call at:{" "}
              <strong className="project-address">
                {serviceDescription.address}
              </strong>{" "}
              has been successfully {sd ? "Updated." : "Created."}
            </span>
          </div>
        </div>
      </div>
      <div className="button-container">
        <button onClick={onGoToServiceDetails} className="button go-to-details">
          Go to Service
        </button>
      </div>
      {/* <Footer /> */}
    </div>
  );
};

export default ServiceConfirmation;
